import '../sections/IG-carousel';
import '../../sass/layout/page/page-blog-entry.scss';

import Swiper, {
    Navigation,
    Autoplay
} from 'swiper';
import myLazyLoad from '../vendors/lazyLoading';

const moreArticlesCarousel = document.querySelector('.more-articles');

if (moreArticlesCarousel) {
    const carousel = moreArticlesCarousel.querySelector('.swiper');
    const nextEl = moreArticlesCarousel.querySelector('.swiper-button-next');
    const prevEl = moreArticlesCarousel.querySelector('.swiper-button-prev');
    const options = {
        modules: [Navigation, Autoplay],
        loop: false,
        spaceBetween: 40,
        speed: 1000,
        autoplay: true,
        autoplay: {
            delay: 5000,
        },
        navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
        },
        breakpoints: {
            1024: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            }
        },
        init: false,
    }

    const swiper = new Swiper(carousel, options);
    
    swiper.on('init', function (swiper) {
        if(swiper.slides.length < 2 && window.innerWidth >= 1024) {
            carousel.querySelector('.swiper-wrapper').style.justifyContent = 'center';
        }
    });

    swiper.on('slideChange', function (swiper) {
        myLazyLoad.update();
    });

    swiper.init();
}

document.querySelectorAll('.blog-article').forEach(article => {
    article.addEventListener('click', function() {
        const link = article.querySelector('a.read-more');
        if (link) {
            window.location.href = link.href;
        }
    });
});